import { stdObject } from "../data/types/stdObject";
import { sendData } from "./sendData";

export const updateNewRate = async (payload: stdObject, logoutAction: any) => {
  console.log("payloadUpdatePriceRate", payload);
  const responseQuickPerson = await sendData({
    endPoint: "updatePriceRate",
    payload,
    logoutAction,
  });
  console.log("responseQuickPerson", responseQuickPerson);
};
